import { getDataType } from '@/common/js/utils';
import * as types from './mutation-types';

const mutations = {
  [types.SET_LOADED_LINKS](state, links) {
    state.loadedAsyncLinks = links;
  },
  [types.SET_GUIDE_APP_FLAG](state, flag) {
    state.guideAppAlertFlag = flag;
  },
  [types.SET_GUIDE_BROWSER_FLAG](state, flag) {
    state.guideBrowserOpenFlag = flag;
  },
  settoken(state, token) {
    state.token = token;
  },
  [types.SET_USER_DATA](state, data) {
    state.user = data;
  },
  SET_PLAY_AU(state, data) {
    state.audioEle = data;
  },
  SET_IOS_WXSDK(state, data) {
    state.isIosInitWxSDK = data;
  },
  SET_CURRENTDATE(state, data) {
    state.currentDateObj = data;
  },
  SET_QIYU(state, data) {
    if (getDataType(data) !== 'object') {
      return;
    }

    const { isStart, unreadNum } = data;
    if (getDataType(isStart) === 'boolean') {
      state.qiYu.isStart = data.isStart;
    }

    if (getDataType(unreadNum) === 'number' && unreadNum >= 0) {
      state.qiYu.unreadNum = data.unreadNum;
    }
  },
  SET_ISUPDATE_CARD(state, data) {
    if (getDataType(data) !== 'object' || !data.isWho || !data.id) {
      return;
    }

    state.isUpdateCard = data;
  },
  SET_THEME_URL(state, data) {
    if (typeof data !== 'string') {
      return;
    }

    state.themeUrl = data;
  },
  SET_STUDYPAGE_HEIGHT(state, data) {
    if (typeof data !== 'number') {
      return;
    }

    state.studyPageHeadHeight = data;
  }
};

export default mutations;
